import { render, staticRenderFns } from "./OrganizationalChartField.vue?vue&type=template&id=4326b4d9&"
import script from "./OrganizationalChartField.vue?vue&type=script&lang=js&"
export * from "./OrganizationalChartField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports